import React from "react";
import "./CertificatePage.scss";

const CertificatePage = ({ images = [], note = "" }) => {
  const handlePrint = () => {
    window.print();
  };
  const mainImage = images[0];

  return (
    <div className="certificate-page">
      <div className="certificate-container">
        <div className="certifi-image-grid">
          <div className="certifi">
            <div className="left-big">
              <img src={mainImage} alt="" />
            </div>
            <div className="certifi-bottom">
              <div className="row-top">
                <div className="certifi-grid-item1 certifi-grid-item">
                  <img
                    className="certifi-item-11 certifi-item-1"
                    src={images[1] || mainImage}
                    alt=""
                  />
                </div>

                <div className="certifi-grid-item1 certifi-grid-item">
                  <img
                    className="certifi-item-11 certifi-item-2"
                    src={images[3] || mainImage}
                    alt=""
                  />
                </div>
              </div>

              <div className="row-bottom">
                <div className="certifi-grid-item1 certifi-grid-item">
                  <img
                    className="certifi-item-11 certifi-item-3"
                    src={images[2] || mainImage}
                    alt=""
                  />
                </div>

                <div className="certifi-grid-item1 certifi-grid-item">
                  <img
                    className="certifi-item-11 certifi-item-4"
                    src={images[4] || mainImage}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="certificate-footer2">
        <p className="certifi-note">{note}</p>
        <button className="certifi-print-btn" onClick={handlePrint}>
          Print the certificate 🖨
        </button>
      </div>
    </div>
  );
};

export default CertificatePage;
